import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCardapio } from '../hooks/useCardapio';
import { StoreView } from './store/StoreView';
import { ErrorState, LoadingState, UnavailableState } from './States';

// Página de um cardápio, resolvida pelo slug da rota (/:slug). Orquestra os
// estados: loading → ready | unavailable | error (com retry).
export function CardapioPage() {
  const { slug } = useParams<{ slug: string }>();
  const [reloadKey, setReloadKey] = useState(0);
  const state = useCardapio(slug, reloadKey);

  const retry = useCallback(() => setReloadKey((k) => k + 1), []);

  // Título da aba reflete o estabelecimento (bom para abas/QR compartilhado).
  useEffect(() => {
    if (state.status === 'ready' && state.data.tenantNome) {
      document.title = `${state.data.tenantNome} · Cardápio`;
    } else {
      document.title = 'Cardápio';
    }
  }, [state]);

  switch (state.status) {
    case 'loading':
      // Item 48: os estados de página inteira são a região principal da página.
      return (
        <main className="estado-pagina">
          <LoadingState />
        </main>
      );
    case 'unavailable':
      // QA-28 M-09 — o retry já existia aqui e só o ErrorState o recebia; o gate/404 também merece ação.
      return (
        <main className="estado-pagina">
          <UnavailableState onRetry={retry} />
        </main>
      );
    case 'error':
      return (
        <main className="estado-pagina">
          <ErrorState onRetry={retry} />
        </main>
      );
    case 'ready':
      return <StoreView cardapio={state.data} slug={slug ?? ''} />;
  }
}
